/** "Load more" under a list that comes in pages (1.0.0-rc.3); nothing when every row is loaded. */
export function LoadMore({ list, shown, noun = 'items' }: { list: { hasMore: boolean; loadMore: () => void; loadingMore: boolean }; shown?: number; noun?: string }) {
  if (!list.hasMore) return null;
  return (
    <div className="load-more" data-testid="load-more">
      {shown != null && <span className="faint">{shown.toLocaleString()} {noun} shown</span>}
      <button type="button" className="btn" disabled={list.loadingMore} onClick={list.loadMore} data-testid="load-more-button">
        {list.loadingMore ? 'Loading…' : 'Load more'}
      </button>
    </div>
  );
}
